export const FullAppTranslations = {
  fullName: {
    label: 'Name'
  },
  suffixName: {
    label: 'Suffix'
  },
  mobile: {
    label: 'Cell Phone',
    type: 'phone_number'
  },
  email: {
    label: 'Email'
  },
  employmentAnnualIncomeAmount: {
    label: 'Annual Income',
    type: 'currency'
  },
  jointWith: {
    label: 'Joint with'
  },
  maritalStatusType: {
    label: 'Marital Status'
  },
  domesticRelationshipIndicator: {
    label: 'Is there a person who is not your legal spouse but who currently has real property rights similar to those of a legal spouse?',
    type: 'indicator'
  },
  domesticRelationshipType: {
    label: 'Type of relationship'
  },
  domesticRelationshipStateCode: {
    label: 'Property Rights State'
  },
  domesticRelationshipTypeOtherDescription: {
    label: 'Description'
  },
  selfDeclaredMilitaryServiceIndicator: {
    label: 'Did you (or your deceased spouse) ever serve, or are you currently serving in the United States Armed Forces?',
    type: 'indicator'
  },
  militaryStatusType: {
    label: 'Military Status'
  },
  militaryServiceToDate: {
    type: 'date',
    label: 'Expiration Date of Service Tour'
  },
  citizenshipResidencyType: {
    label: 'Citizenship'
  },
  dependentCount: {
    label: 'Dependents'
  },
  dependentAgeYearsCount: {
    label: 'Age of Dependent'
  },
  alternatePhone: {
    label: 'Home Phone',
    type: 'phone_number'
  },
  ssn: {
    label: 'Social Security Number',
    type: 'ssn'
  },
  borrowerBirthDate: {
    label: 'Date of Birth',
    type: 'date'
  },
  street: {
    label: 'Street Address'
  },
  unit: {
    label: 'Unit Number'
  },
  cityName: {
    label: 'City'
  },
  stateCode: {
    label: 'State',
    type: 'state_code'
  },
  postalCode: {
    label: 'Zip Code',
    type: 'zip_code'
  },
  housingExpenseType: {
    label: 'Rent/Own'
  },
  housingExpensePaymentAmount: {
    label: 'Rent Per Month',
    type: 'currency'
  },
  borrowerResidencyDurationYearsCount: {
    label: 'Years at this address'
  },
  borrowerResidencyDurationMonthsCount: {
    label: 'Months at this address'
  },
  financedUnitCount: {
    label: 'Number of Units'
  },
  propertyCurrentUsageType: {
    label: 'Home use'
  },
  neighborhoodHousingType: {
    label: 'Property Type'
  },
  propertyValuationAmount: {
    label: 'Home value',
    type: 'currency'
  },
  attachmentType: {
    label: 'Property Attached/Detached'
  },
  propertyMixedUsageIndicator: {
    label: 'If you will occupy the property, will you set aside space within the property to operate your own business ',
    type: 'indicator'
  },
  propertyStructureBuiltYear: {
    label: 'Year Built'
  },
  homeownersAssociationDuesPaymentAmount: {
    label: 'HOA Fee',
    type: 'currency'
  },
  currentTitleOwner: {
    label: 'Title currently held by'
  },
  futureTitleOwner: {
    label: 'Title will be held by'
  },
  titleMannerHeld: {
    label: 'Manner in which the title will be held'
  },
  indianCountryLandTenure: {
    label: 'Is your property part of an Indian Country land Tenure?',
    type: 'indicator'
  },
  indianCountryLandTenureType: {
    label: 'Indian Country Land Tenure'
  },
  propertyPartOfTrust: {
    label: 'Is your property part of  Trust?',
    type: 'indicator'
  },
  trustDetails: {
    label: 'Trust Information'
  },
  phone: {
    label: 'Phone',
    type: 'phone_number'
  },
  isPropertyAddress: {
    label: 'Same as subject property address'
  },
  sameAsPropertyAddress: {
    label: 'Same as subject property address',
    type: 'indicator'
  },
  present: {
    label: 'Present Address',
    type: 'text'
  },
  previous: {
    label: 'Previous Address',
    type: 'text'
  },
  mailing: {
    label: 'Mailing Address',
    type: 'text'
  },
  presentAddressEditHelp: {
    label: 'Please provide your address history for a minimum of 2 years.',
    type: 'text'
  }
};
//# sourceMappingURL=index.js.map